<template>
    <div>
        <h1 style="margin: 0 auto; margin-top: 60px; text-align: left; padding: 0 30px;">404 ERROR. <br/>Page Not Found.</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
